import { VisibilityState } from '@tanstack/react-table';
import { useState } from 'react';
import { ColumnGroup } from '../types';
import { getColumnId } from '../utils';

interface ExtendedColumnDef {
  showInSelector?: boolean;
}

export function useColumnVisibility<TData, TValue>(
  groups: ColumnGroup<TData, TValue>[],
  defaultVisibleColumns?: string[]
) {
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(
    () => {
      const initial: VisibilityState = {};
      groups.forEach((group) => {
        const isSticky = group.sticky === 'left' || group.sticky === 'right';
        group.columns.forEach((col) => {
          const columnId = getColumnId(col);
          const columnDef = col as ExtendedColumnDef;
          // Columns in sticky groups or with showInSelector: false should always be visible
          if (isSticky || columnDef.showInSelector === false) {
            initial[columnId] = true;
          } else if (
            defaultVisibleColumns !== undefined &&
            defaultVisibleColumns.length > 0
          ) {
            // If defaultVisibleColumns is provided AND has items, only show columns in that list
            initial[columnId] = defaultVisibleColumns.includes(columnId);
          } else {
            // Otherwise, show all columns by default
            initial[columnId] = true;
          }
        });
      });
      return initial;
    }
  );

  return { columnVisibility, setColumnVisibility } as const;
}
